<form
  fxLayout="column"
  fxLayoutAlign="start center"
  fxLayoutGap="16px"
  [formGroup]="form"
  (ngSubmit)="submit()"
>
  <ng-content />
  <mat-form-field>
    <mat-label>Password</mat-label>
    <input
      matInput
      type="password"
      formControlName="password"
      [required]="true"
    />
    <mat-error *ngIf="form.controls.password.hasError('required')">
      Password is required
    </mat-error>
    <mat-error *ngIf="form.controls.password.hasError('minlength')">
      Password is too short
    </mat-error>
  </mat-form-field>
  <button type="submit" hidden></button>
</form>
